/** 方案-服务项目API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/st/stSolutionService';
/**
 * 分页查询方案-服务项目
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StSolutionService> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询方案-服务项目列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StSolutionService> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个方案-服务项目
 *
 * @param id 方案-服务项目ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StSolutionService> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存方案-服务项目
 *
 * @param params 方案-服务项目信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新方案-服务项目信息
 *
 * @param params 方案-服务项目信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除方案-服务项目
 *
 * @param id 方案-服务项目ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除方案-服务项目
 *
 * @param ids 方案-服务项目ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
